"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _ramdaAdjunct = require("ramda-adjunct");

var _default = (0, _ramda.curryN)(3, (keyNames, keyNamesMap, obj) => {
  return (0, _ramda.pipe)((0, _ramda.pick)(keyNames), (0, _ramdaAdjunct.renameKeys)(keyNamesMap))(obj);
});

exports.default = _default;